import React, { useEffect, useState, useRef, useContext } from 'react';
import classNames from 'classnames';

import './Summary.scss';
import useIsMobile from 'src/hooks/useIsMobile';
import AppModeContext from 'src/containers/AppMode/AppMode.context';

interface Component {
  children?: React.ReactNode;
}

const Summary = ({ children }: Component) => {
  const [summaryNotVisible, setNotVisible] = useState(false);
  const summary = useRef(null);
  const { RETAIL_MODE } = useContext(AppModeContext);
  const isRetail = RETAIL_MODE;

  const mobile = useIsMobile();

  useEffect(() => {
    const top = summary.current?.getBoundingClientRect().top;
    //Check if summary is not visble without scroll
    setNotVisible(top + 72 >= 0 && top - 72 <= window.innerHeight);
  }, []);

  return (
    <div
      ref={ summary }
      className={
        classNames({
          summary: true,
          'summary--desktop-fixed': !mobile && summaryNotVisible,
          'summary--fixed-retail': isRetail
        })
      }
    >
      { children }
    </div>
  );
};

export default Summary;
